import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import DataTable from '../../components/ui/data-table';
import EmptyState from '../../components/ui/empty-state.jsx';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import { useAssignments } from '../../hooks/useAssignments';
import { FileText, Plus } from 'lucide-react';

const TeacherAssignments = () => {
  const { assignments, loading, error, fetchAssignments } = useAssignments({ scope: 'teacher' });

  const columns = [
    { id: 'title', header: 'Title', accessorKey: 'title', sortable: true },
    { id: 'subject', header: 'Subject', accessorKey: 'subjectName', sortable: true },
    { id: 'class', header: 'Class', accessorKey: 'className' },
    { id: 'dueDate', header: 'Due Date', accessorKey: 'dueDate', sortable: true },
    { id: 'submissions', header: 'Submissions', accessorKey: 'submittedCount' },
    {
      id: 'actions',
      header: 'Actions',
      cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <Button size="sm" onClick={() => window.location.assign(`/dashboard/assignments/${row.id}`)}>Open</Button>
          <Button size="sm" variant="outline" onClick={() => window.location.assign(`/dashboard/assignments/${row.id}/grade`)}>Grade</Button>
        </div>
      )
    }
  ];

  if (loading) return <LoadingSpinner />;
  if (error) return (
    <div className="p-6">
      <Card>
        <CardContent className="p-6">
          <p className="text-red-600 text-sm">{String(error)}</p>
          <Button className="mt-3" onClick={() => fetchAssignments()}>Retry</Button>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">My Assignments</h2>
        <Button onClick={() => window.location.assign('/dashboard/assignments/create')}>
          <Plus className="w-4 h-4 mr-2" /> Create Assignment
        </Button>
      </div>

      {(!assignments || assignments.length === 0) ? (
        <EmptyState 
          icon={FileText}
          title="No assignments yet"
          description="Create your first assignment to get started."
          action
          actionLabel="Create Assignment"
          onAction={() => window.location.assign('/dashboard/assignments/create')}
        />
      ) : (
        <Card>
          <CardContent className="p-0">
            <DataTable data={assignments} columns={columns} searchable />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default TeacherAssignments;


